/* eslint-disable class-methods-use-this */
import Model from './Model';
import AssessmentQuestions from '../data/AssessmentQuestions';

export default class AssessmentAnswer extends Model {
    // noinspection JSMethodCanBeStatic
    resource() {
        return 'assessment_answers';
    }

    async getAssessmentQuestion() {
        return AssessmentQuestions.findResource(this.assessmentQuestion);
    }
}
